import React from 'react'
import { Button, Dialog, Flex, Text, Strong, Code } from '@radix-ui/themes'
import { AlertTriangleIcon, CalendarIcon, UserIcon, CarIcon } from 'lucide-react'

import { fechaIsoToFull } from '../utils/utils'
import contactedViaDealTranslate from '../utils/contactedViaDealTranslate'

interface ExistingDeal {
  _id: string
  createdAt: string
  contactedVia: string
  vehicle: {
    brand: string
    model: string
    plate: string
  }
  client: {
    firstname: string
    lastname: string
  }
}

interface DuplicateDealModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  existingDeal: ExistingDeal
}

export const DuplicateDealModal: React.FC<DuplicateDealModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  existingDeal,
}) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onCancel}>
      <Dialog.Content maxWidth="500px">
        <Dialog.Title>
          <Flex align="center" gap="2">
            <AlertTriangleIcon size={20} className="text-amber-600" />
            Negocio Duplicado Detectado
          </Flex>
        </Dialog.Title>

        <Dialog.Description size="2" mb="4">
          Ya existe un negocio activo con el mismo cliente y vehículo.
        </Dialog.Description>

        <Flex direction="column" gap="3" mb="4">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
            <Text size="2" weight="medium" className="text-amber-800">
              Negocio Existente:
            </Text>

            <Flex direction="column" gap="2" mt="2">
              <Flex align="center" gap="2">
                <UserIcon size={14} className="text-gray-500" />
                <Text size="2">
                  <Strong>
                    {existingDeal.client.firstname} {existingDeal.client.lastname}
                  </Strong>
                </Text>
              </Flex>

              <Flex align="center" gap="2">
                <CarIcon size={14} className="text-gray-500" />
                <Text size="2">
                  {existingDeal.vehicle.brand} {existingDeal.vehicle.model}
                  <Code className="ml-1">{existingDeal.vehicle.plate}</Code>
                </Text>
              </Flex>

              <Flex align="center" gap="2">
                <CalendarIcon size={14} className="text-gray-500" />
                <Text size="2">Creado: {fechaIsoToFull(existingDeal.createdAt)}</Text>
              </Flex>

              <Flex align="center" gap="2">
                <Text size="2">Contactado vía: {contactedViaDealTranslate[existingDeal.contactedVia]}</Text>
              </Flex>
            </Flex>
          </div>
        </Flex>

        <Text size="2" color="gray" mb="4">
          ¿Desea continuar y crear un nuevo negocio de todas formas?
        </Text>

        <Flex gap="3" justify="end">
          <Dialog.Close>
            <Button variant="soft" color="gray" onClick={onCancel}>
              Cancelar
            </Button>
          </Dialog.Close>

          <Button variant="solid" color="amber" onClick={onConfirm}>
            Continuar de todas formas
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  )
}
